module.exports = __webpack_public_path__ + "img/partner-1.55708300.png";